<template>
    <div>
        <section class="breadcrumb-section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }"
                                >Home</router-link
                            >
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'Myorder' }"
                                >My Account</router-link
                            >
                        </li>
                        <li class="breadcrumb-item active">Pay Now</li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="shipping_payment_detail shipping_payment pt-0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-lg-6 pr_50 mobile_pr_15">
                        <div
                            class="white_box py_52 px_50 shipping_fl_left payment-shipment-mg card-shipping"
                        >
                            <form
                                method="post"
                                @submit.prevent="proceedToPay"
                                data-vv-scope="paymentform"
                                class="f_fl_left"
                            >
                                <div class="payment_method">
                                    <h1 class="font_size_28">Payment method</h1>

                                    <div
                                        class="radio_butoons_headding d-flex mt_0 border-top-0 border-bottom"
                                        v-for="(
                                            payment_methods, indx
                                        ) in all_payment_methods"
                                        :key="indx"
                                        :style="
                                            payment_methods.expired_time <
                                            new Date()
                                                ? 'display:none !important'
                                                : ''
                                        "
                                    >
                                        <p class="m-0">
                                            <input
                                                type="radio"
                                                :value="
                                                    payment_methods.customerPaymentProfileId
                                                "
                                                :id="
                                                    payment_methods.customerPaymentProfileId
                                                "
                                                name="radio-group"
                                                :checked="
                                                    payment_methods.customerPaymentProfileId ==
                                                    selected_card.customerPaymentProfileId
                                                "
                                                @change="
                                                    selectPaymentMethod(
                                                        payment_methods.customerPaymentProfileId,
                                                        payment_methods.expired_time,
                                                        $event
                                                    )
                                                "
                                            />
                                            <!-- v-model="order_data.is_credit_card" -->
                                            <label
                                                :for="
                                                    payment_methods.customerPaymentProfileId
                                                "
                                                class="m-0"
                                            >
                                                **** **** ****
                                                <span class="cc_opa">
                                                    {{
                                                        payment_methods.payment
                                                            .creditCard
                                                            .cardNumber
                                                            ? payment_methods.payment.creditCard.cardNumber.substr(
                                                                  -4
                                                              )
                                                            : ""
                                                    }}
                                                </span>
                                            </label>
                                        </p>
                                        <div
                                            class="ml-auto mr_6 cards_img"
                                            v-if="
                                                payment_methods.payment
                                                    .creditCard.cardType ==
                                                'Visa'
                                            "
                                        >
                                            <img
                                                :src="
                                                    base_url +
                                                    '/maincss/images/add_visa_logo.png'
                                                "
                                                alt=" "
                                            />
                                        </div>
                                        <div
                                            class="ml-auto mr_6 cards_img"
                                            v-else-if="
                                                payment_methods.payment
                                                    .creditCard.cardType ==
                                                'MasterCard'
                                            "
                                        >
                                            <img
                                                :src="
                                                    base_url +
                                                    '/maincss/images/master_card_logo.png'
                                                "
                                                alt=" "
                                            />
                                        </div>
                                        <div
                                            class="ml-auto mr_6 cards_img"
                                            v-else-if="
                                                payment_methods.payment
                                                    .creditCard.cardType ==
                                                'JCB'
                                            "
                                        >
                                            <img
                                                :src="
                                                    base_url +
                                                    '/maincss/images/jcb_logo.svg'
                                                "
                                                alt=" "
                                            />
                                        </div>
                                        <div
                                            class="ml-auto mr_6 cards_img"
                                            v-else-if="
                                                payment_methods.payment
                                                    .creditCard.cardType ==
                                                'Discover'
                                            "
                                        >
                                            <img
                                                :src="
                                                    base_url +
                                                    '/maincss/images/discover_logo.svg'
                                                "
                                                alt=" "
                                            />
                                        </div>
                                        <div
                                            class="ml-auto mr_6 cards_img"
                                            v-else-if="
                                                payment_methods.payment
                                                    .creditCard.cardType ==
                                                'AmericanExpress'
                                            "
                                        >
                                            <img
                                                :src="
                                                    base_url +
                                                    '/maincss/images/american_express_logo.svg'
                                                "
                                                alt=" "
                                            />
                                        </div>
                                        <div
                                            class="ml-auto mr_6 cards_img"
                                            v-else
                                        >
                                            <img
                                                :src="
                                                    base_url +
                                                    '/maincss/images/unknown_card_logo.svg'
                                                "
                                                alt=" "
                                            />
                                        </div>
                                    </div>

                                    <div
                                        class="card-pay radio_butoons_headding d-flex mt_0 border-top-0 border-bottom"
                                    >
                                        <a
                                            href="javascript:void(0);"
                                            class="payment_box d-flex justify-content-center align-items-center flex-column text-center h-100"
                                            data-keyboard="false"
                                            data-toggle="modal"
                                            data-target="#add_payment_method_model"
                                            data-dismiss="modal"
                                        >
                                            <a><b>+ Add New Card </b></a>
                                        </a>

                                        <img
                                            src="/maincss/images/cards.png"
                                            alt=" "
                                            class="ml-auto mr_6 cards_img"
                                        />
                                    </div>
                                    <div>
                                        <div
                                            class="two_input_one_row mt_36 payment_bottom"
                                        >
                                            <div class="form-group card-no">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    id="Card Number"
                                                    name="CardNumber"
                                                    placeholder="Enter Card Number"
                                                    :value="
                                                        selected_card.cardnumber
                                                            ? '#### #### #### ' +
                                                              selected_card.cardnumber
                                                            : undefined
                                                    "
                                                    v-validate="
                                                        !is_pay_way_terms
                                                            ? 'required|min:17|max:19'
                                                            : ''
                                                    "
                                                    data-vv-as="Card Number"
                                                    disabled
                                                />
                                                <label>Card number</label>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'paymentform.CardNumber'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "paymentform.CardNumber"
                                                        )
                                                    }}
                                                </small>
                                            </div>

                                            <div
                                                class="form-group position-relative expiration"
                                                style="width: 60px"
                                            >
                                                <label
                                                    class="select_option_label"
                                                    >Month</label
                                                >
                                                <select
                                                    class="form-control bg-transparent"
                                                    v-model="
                                                        selected_card.cardexpiremonth
                                                    "
                                                    name="Expiration Month"
                                                    v-validate="'required'"
                                                    data-vv-as="Expiration Month"
                                                    disabled
                                                >
                                                    <option
                                                        v-for="n in 12"
                                                        :value="
                                                            10 > n ? '0' + n : n
                                                        "
                                                        :key="n"
                                                        :disabled="
                                                            n <
                                                                new Date().getMonth() +
                                                                    1 &&
                                                            changedYear <=
                                                                currentYear
                                                        "
                                                    >
                                                        {{
                                                            10 > n ? "0" + n : n
                                                        }}
                                                    </option>
                                                </select>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'paymentform.Expiration Month'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "paymentform.Expiration Month"
                                                        )
                                                    }}
                                                </small>
                                            </div>
                                            <div
                                                class="form-group position-relative expiration"
                                                style="width: 60px"
                                            >
                                                <label
                                                    class="select_option_label"
                                                    >Year</label
                                                >
                                                <select
                                                    class="form-control bg-transparent"
                                                    v-model="
                                                        selected_card.cardexpireyear
                                                    "
                                                    name="Expiration Year"
                                                    v-validate="'required'"
                                                    data-vv-as="Expiration Year"
                                                    disabled
                                                    @change="
                                                        changeCardYear(
                                                            $event,
                                                            selected_card
                                                        )
                                                    "
                                                >
                                                    <option
                                                        v-for="year in years"
                                                        :key="year"
                                                        :value="
                                                            year
                                                                ? year
                                                                      .toString()
                                                                      .substr(
                                                                          -2
                                                                      )
                                                                : ''
                                                        "
                                                    >
                                                        {{ year }}
                                                    </option>
                                                </select>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'paymentform.Expiration Year'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "paymentform.Expiration Year"
                                                        )
                                                    }}
                                                </small>
                                            </div>
                                            <div
                                                class="form-group securit_code"
                                            >
                                                <input
                                                    maxlength="3"
                                                    type="text"
                                                    class="form-control"
                                                    id="Security Code"
                                                    placeholder="Enter Code "
                                                    name="Security Code"
                                                    v-model="
                                                        selected_card.cardsecuritycode
                                                    "
                                                    v-validate="
                                                        !is_pay_way_terms
                                                            ? 'required|numeric|length:3'
                                                            : ''
                                                    "
                                                    @input="cardSecurityFormat"
                                                    :disabled="
                                                        !selected_card.customerPaymentProfileId
                                                    "
                                                />
                                                <label>Security code</label>
                                                <div
                                                    class="alert-icon pb-2"
                                                    data-toggle="tooltip"
                                                    data-placement="bottom"
                                                    v-tooltip="
                                                        'Credit Card Security Code'
                                                    "
                                                >
                                                    <img
                                                        src="/maincss/images/information.svg"
                                                        alt=" "
                                                    />
                                                </div>
                                                <span class="highlight"></span>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'paymentform.Security Code'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "paymentform.Security Code"
                                                        )
                                                    }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-if="credit_limit > 0"
                                        class="radio_butoons_headding pay_via_terms_box d-flex mt_16 border-top-0 border-bottom"
                                    >
                                        <div class="position-relative">
                                            <p class="m-0">
                                                <input
                                                    type="radio"
                                                    value="1"
                                                    id="test2"
                                                    checked
                                                    name="radio-group"
                                                />
                                                <label for="test2" class="m-0">
                                                    <span class="cc_opa"
                                                        >Pay via terms</span
                                                    >
                                                </label>
                                            </p>
                                            <div
                                                class="alert-icon pb-2"
                                                data-toggle="tooltip"
                                                data-placement="bottom"
                                                v-tooltip="'Pay via terms'"
                                            >
                                                <img
                                                    src="/maincss/images/information.svg"
                                                    alt=" "
                                                />
                                            </div>
                                        </div>

                                        <span
                                            class="text-right ml-auto mr_6 cards_img font-weight-bold heading5"
                                            >${{ credit_limit }}</span
                                        >
                                    </div>
                                </div>

                                <!-- TERM PAYMENT -->
                                <div
                                    class="coupon mt_20"
                                    v-if="total_orders > 1"
                                >
                                    <div class="row align-items-end">
                                        <div
                                            class="col-md-12 col-lg-12 col-xlg-9"
                                        >
                                            <div id="accordion">
                                                <div
                                                    class="form-check p-0 pay-terms"
                                                >
                                                    <div
                                                        class="pay card-pay radio_butoons_headding d-flex mt_0 border-top-0 border-bottom"
                                                    >
                                                        <!-- <div class="label-popup" data-toggle="collapse" data-target="#payWayTerms" aria-expanded="true" aria-controls="payWayTerms"> -->
                                                        <div
                                                            class="label-popup"
                                                            aria-expanded="true"
                                                            aria-controls="payWayTerms"
                                                        >
                                                            <input
                                                                class="form-check-input"
                                                                type="radio"
                                                                :checked="
                                                                    is_pay_way_terms
                                                                "
                                                                @click="
                                                                    selectPaymentOption(
                                                                        'pay_way_terms'
                                                                    )
                                                                "
                                                                name="radio-group"
                                                                value=""
                                                                id="flexCheck"
                                                            />
                                                            <label
                                                                class="form-check-label"
                                                                for="flexCheck"
                                                            >
                                                                Pay with terms
                                                                <img
                                                                    src="/maincss/images/information.svg"
                                                                    alt=" "
                                                                />
                                                            </label>
                                                            <span
                                                                class="term-amount"
                                                                v-if="
                                                                    term_payment_info.creditlimit
                                                                "
                                                                >{{
                                                                    icPriceFormat(
                                                                        term_payment_info.creditlimit
                                                                    )
                                                                }}</span
                                                            >
                                                            <span
                                                                class="term-amount"
                                                                v-else
                                                                >{{
                                                                    icPriceFormat(
                                                                        0
                                                                    )
                                                                }}</span
                                                            >
                                                        </div>
                                                    </div>
                                                    <div
                                                        id="payWayTerms"
                                                        class="collapse"
                                                        :class="{
                                                            show: is_pay_way_terms
                                                        }"
                                                        aria-labelledby="headingOne"
                                                        data-parent="#accordion"
                                                    >
                                                        <div class="pay-box">
                                                            <div
                                                                class="balance-box"
                                                            >
                                                                <h5>
                                                                    Credit
                                                                    Limit:
                                                                </h5>
                                                                <h3
                                                                    v-if="
                                                                        term_payment_info.creditlimit
                                                                    "
                                                                >
                                                                    {{
                                                                        icPriceFormat(
                                                                            term_payment_info.creditlimit
                                                                        )
                                                                    }}
                                                                </h3>
                                                                <h3 v-else>
                                                                    {{
                                                                        icPriceFormat(
                                                                            0
                                                                        )
                                                                    }}
                                                                </h3>
                                                            </div>

                                                            <div
                                                                class="balance-block"
                                                            >
                                                                <div
                                                                    class="odered-balance"
                                                                >
                                                                    <h5>
                                                                        Unpaid
                                                                        Invoices:
                                                                    </h5>
                                                                    <h3
                                                                        class="text-danger"
                                                                        v-if="
                                                                            term_payment_info.unpaid_invoices
                                                                        "
                                                                    >
                                                                        {{
                                                                            icPriceFormat(
                                                                                term_payment_info.unpaid_invoices
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                    <h3
                                                                        class="text-danger"
                                                                        v-else
                                                                    >
                                                                        {{
                                                                            icPriceFormat(
                                                                                0
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                </div>
                                                                <div
                                                                    class="odered-balance"
                                                                >
                                                                    <h5>
                                                                        Overdue
                                                                        balance:
                                                                    </h5>
                                                                    <h3
                                                                        :class="{
                                                                            'text-danger':
                                                                                term_payment_info.overdue_balance <
                                                                                0
                                                                        }"
                                                                        v-if="
                                                                            term_payment_info.overdue_balance
                                                                        "
                                                                    >
                                                                        {{
                                                                            icPriceFormat(
                                                                                term_payment_info.overdue_balance
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                    <h3 v-else>
                                                                        {{
                                                                            icPriceFormat(
                                                                                0
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                </div>
                                                                <div
                                                                    class="odered-balance"
                                                                >
                                                                    <h5>
                                                                        Unbilled
                                                                        Orders:
                                                                    </h5>
                                                                    <h3
                                                                        class="text-danger"
                                                                        v-if="
                                                                            term_payment_info.unbilled_orders
                                                                        "
                                                                    >
                                                                        {{
                                                                            icPriceFormat(
                                                                                term_payment_info.unbilled_orders
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                    <h3
                                                                        class="text-danger"
                                                                        v-else
                                                                    >
                                                                        {{
                                                                            icPriceFormat(
                                                                                0
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                </div>
                                                                <div
                                                                    class="odered-balance"
                                                                >
                                                                    <h5>
                                                                        Unapplied
                                                                        Credits:
                                                                    </h5>
                                                                    <h3
                                                                        :class="{
                                                                            'text-danger':
                                                                                term_payment_info.unapplied_credits <
                                                                                0
                                                                        }"
                                                                        v-if="
                                                                            term_payment_info.unapplied_credits
                                                                        "
                                                                    >
                                                                        {{
                                                                            icPriceFormat(
                                                                                term_payment_info.unapplied_credits
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                    <h3 v-else>
                                                                        {{
                                                                            icPriceFormat(
                                                                                0
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                </div>
                                                                <div
                                                                    class="odered-balance"
                                                                >
                                                                    <h5>
                                                                        Available
                                                                        on
                                                                        Account:
                                                                    </h5>
                                                                    <h3
                                                                        :class="{
                                                                            'text-danger':
                                                                                term_payment_info.avalaible_on_account <
                                                                                0
                                                                        }"
                                                                        v-if="
                                                                            term_payment_info.avalaible_on_account
                                                                        "
                                                                    >
                                                                        {{
                                                                            icPriceFormat(
                                                                                term_payment_info.avalaible_on_account
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                    <h3 v-else>
                                                                        {{
                                                                            icPriceFormat(
                                                                                0
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                </div>
                                                                <div
                                                                    class="odered-balance"
                                                                >
                                                                    <h5>
                                                                        Current
                                                                        Order:
                                                                    </h5>
                                                                    <h3
                                                                        class="text-danger"
                                                                    >
                                                                        {{
                                                                            icPriceFormat(
                                                                                grand_total_price
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                </div>
                                                            </div>

                                                            <div
                                                                class="balance-box"
                                                            >
                                                                <h5>
                                                                    Available
                                                                    Credit:
                                                                </h5>
                                                                <h3
                                                                    v-if="
                                                                        term_payment_info.avalaible_on_account
                                                                    "
                                                                >
                                                                    {{
                                                                        icPriceFormat(
                                                                            term_payment_info.avalaible_on_account -
                                                                                grand_total_price
                                                                        )
                                                                    }}
                                                                </h3>
                                                                <h3 v-else>
                                                                    {{
                                                                        icPriceFormat(
                                                                            0
                                                                        )
                                                                    }}
                                                                </h3>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="coupon mt_20">
                                    <div class="row align-items-end">
                                        <div
                                            class="col-md-12 col-lg-12 col-xlg-9"
                                        >
                                            <p class="mb-0 font_size_14">
                                                PO number ( Optional )
                                            </p>
                                            <div class="d-flex coupon">
                                                <div
                                                    class="form-group mt-1 ml-0 w-100"
                                                >
                                                    <input
                                                        type="text"
                                                        placeholder="Enter PO number"
                                                        class="form-control"
                                                        v-model="po_number"
                                                    />
                                                    <span
                                                        class="highlight"
                                                    ></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="gifts_cards">
                                    <div class="row align-items-end">
                                        <div
                                            class="col-md-12 col-lg-9 col-xlg-9"
                                        >
                                            <div id="accordion">
                                                <div
                                                    class="form-check p-0 add-gift-code collapsed"
                                                >
                                                    <div
                                                        class="choice-gift"
                                                        data-toggle="collapse"
                                                        data-target="#collapseOne"
                                                        aria-expanded="true"
                                                        aria-controls="collapseOne"
                                                    >
                                                        <input
                                                            class="form-check-input"
                                                            type="checkbox"
                                                            value=""
                                                            id="flexCheckDefault"
                                                        />
                                                        <div
                                                            class="label-popup"
                                                        >
                                                            <label
                                                                class="form-check-label"
                                                                for="flexCheckDefault"
                                                            >
                                                                Add gift card
                                                                codes one at a
                                                                time
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div
                                                        id="collapseOne"
                                                        class="collapse"
                                                        aria-labelledby="headingOne"
                                                        data-parent="#accordion"
                                                    >
                                                        <div
                                                            class="d-flex add-gift-block"
                                                        >
                                                            <div
                                                                class="d-md-flex gift_card"
                                                            >
                                                                <div
                                                                    class="form-group ml-0 gift_card_number"
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Gift card number"
                                                                        value=""
                                                                        class="form-control"
                                                                        v-on:change="
                                                                            (
                                                                                event
                                                                            ) =>
                                                                                setGiftCardNumber(
                                                                                    event
                                                                                )
                                                                        "
                                                                    />
                                                                    <span
                                                                        class="highlight"
                                                                    ></span>
                                                                </div>

                                                                <div
                                                                    class="form-group enter_pin ml-auto"
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Enter PIN  "
                                                                        value=""
                                                                        class="form-control"
                                                                        v-on:change="
                                                                            (
                                                                                event
                                                                            ) =>
                                                                                setGiftCardPin(
                                                                                    event
                                                                                )
                                                                        "
                                                                    />
                                                                    <span
                                                                        class="highlight"
                                                                    ></span>

                                                                    <div
                                                                        data-toggle="tooltip"
                                                                        data-placement="bottom"
                                                                        v-tooltip="
                                                                            'Gift Card Number'
                                                                        "
                                                                        class="alert-icon pb-2"
                                                                        data-original-title="Tooltip on bottom"
                                                                    >
                                                                        <img
                                                                            src="/maincss/images/information.svg"
                                                                            alt=" "
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="col-md-12 col-lg-3 col-xlg-3 text-xlg-right add_btn"
                                                            >
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    class="btn btn_outline_primary border_primary_blue text_primary_blue ml-auto py_10 px_42 mt-4 mt-xlg-0"
                                                                    >ADD</a
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="coupon mt_20">
                                    <div class="row align-items-end">
                                        <div
                                            class="col-md-12 col-lg-9 col-xlg-9"
                                        >
                                            <div id="accordion">
                                                <div
                                                    class="form-check p-0 add-gift-code collapsed"
                                                >
                                                    <div class="choice-gift">
                                                        <input
                                                            class="form-check-input"
                                                            type="checkbox"
                                                            value=""
                                                            id="flexCheckcoupon"
                                                        />
                                                        <div
                                                            class="label-popup"
                                                            data-toggle="collapse"
                                                            data-target="#collapseTwo"
                                                            aria-expanded="false"
                                                            aria-controls="collapseTwo"
                                                        >
                                                            <label
                                                                class="form-check-label"
                                                                for="flexCheckcoupon"
                                                            >
                                                                Apply a Coupon
                                                                Code
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div
                                                        id="collapseTwo"
                                                        class="collapse"
                                                        aria-labelledby="headingTwo"
                                                        data-parent="#accordion"
                                                    >
                                                        <div
                                                            class="d-flex coupon-block"
                                                        >
                                                            <div
                                                                class="d-flex coupon w-100"
                                                            >
                                                                <div
                                                                    class="form-group ml-0 w-100"
                                                                >
                                                                    <input
                                                                        type="text"
                                                                        placeholder="Enter code"
                                                                        value=""
                                                                        class="form-control"
                                                                        v-on:change="
                                                                            (
                                                                                event
                                                                            ) =>
                                                                                setCouponCode(
                                                                                    event
                                                                                )
                                                                        "
                                                                    />
                                                                    <span
                                                                        class="highlight"
                                                                    ></span>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="col-md-12 col-lg-3 col-xlg-3 text-xlg-right add_btn"
                                                            >
                                                                <a
                                                                    href="javascript:void(0);"
                                                                    class="btn btn_outline_primary border_primary_blue text_primary_blue ml-auto py_10 px_34"
                                                                    >Apply</a
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="coupon mt_20">
                                    <div class="row align-items-end">
                                        <div
                                            class="col-md-12 col-lg-12 col-xlg-9"
                                        >
                                            <div id="accordion">
                                                <div
                                                    class="form-check comment-box collapsed"
                                                >
                                                    <input
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        value=""
                                                        id="flexCheckComment"
                                                    />
                                                    <div
                                                        class="label-popup"
                                                        data-toggle="collapse"
                                                        data-target="#collapseThree"
                                                        aria-expanded="false"
                                                        aria-controls="collapseThree"
                                                    >
                                                        <label
                                                            class="form-check-label"
                                                            for="flexCheckComment"
                                                        >
                                                            Any Special Comments
                                                        </label>
                                                    </div>

                                                    <div
                                                        id="collapseThree"
                                                        class="collapse"
                                                        aria-labelledby="headingThree"
                                                        data-parent="#accordion"
                                                    >
                                                        <div
                                                            class="d-flex coupon"
                                                        >
                                                            <div
                                                                class="form-group ml-0 w-100 comment-text"
                                                            >
                                                                <textarea
                                                                    class="form-control mb_0 special_cmt_textarea any_special_comments_area"
                                                                    placeholder="Enter here"
                                                                    v-on:change="
                                                                        (
                                                                            event
                                                                        ) =>
                                                                            setSpecialComment(
                                                                                event
                                                                            )
                                                                    "
                                                                >
                                                                </textarea>
                                                                <span
                                                                    class="highlight"
                                                                ></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mt_36">
                                    <button
                                        v-if="is_pay_way_terms"
                                        @click="payViaTerms"
                                        type="button"
                                        class="btn btn_orange bg_primary_orange text_white d-block mt_36 py_22"
                                        style="width: 100%; max-width: 100%"
                                    >
                                        Make Payment
                                    </button>
                                    <button
                                        v-else
                                        type="submit"
                                        class="btn btn_orange bg_primary_orange text_white d-block mt_36 py_22"
                                        style="width: 100%; max-width: 100%"
                                    >
                                        Make Payment
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-6 pr_50 mobile_pr_15">
                        <div
                            class="cart_summary h-100 white_box py_52 px_52 cart-shipping-address"
                        >
                            <div
                                v-if="additional_fees.color_fees"
                                class="total_coast d-flex text-right"
                            >
                                <h5>Color Fees:</h5>
                                <h3>
                                    {{
                                        icPriceFormat(
                                            additional_fees.color_fees
                                        )
                                    }}
                                </h3>
                            </div>
                            <div
                                v-if="additional_fees.item_fees"
                                class="total_coast d-flex text-right"
                            >
                                <h5>Item Fees:</h5>
                                <h3>
                                    {{
                                        icPriceFormat(additional_fees.item_fees)
                                    }}
                                </h3>
                            </div>
                            <div
                                v-if="additional_fees.order_fees"
                                class="total_coast d-flex text-right"
                            >
                                <h5>Order Fees:</h5>
                                <h3>
                                    {{
                                        icPriceFormat(
                                            additional_fees.order_fees
                                        )
                                    }}
                                </h3>
                            </div>
                            <div
                                class="total_coast grand-total d-flex text-right"
                            >
                                <h5>Total Due:</h5>
                                <h3>{{ icPriceFormat(grand_total_price) }}</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- INSUFFICIENTS FUNDS -->
        <div
            class="modal login-form-popup fade payViaTerms_popup"
            id="insufficientFundsModal"
            tabindex="-1"
            aria-labelledby="payViaTerms"
            aria-hidden="true"
            data-keyboard="false"
            data-backdrop="static"
        >
            <div class="modal-dialog modal-dialog-centered modal-dialog">
                <div class="modal-content">
                    <div
                        class="modal-body"
                        style="overflow-y: auto"
                        v-if="term_payment_info"
                    >
                        <a
                            href="#"
                            class="popup-close"
                            id="popup-close-payViaTerms"
                            data-dismiss="modal"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>
                        <div
                            class="login-form"
                            v-if="
                                parseFloat(grand_total_price) >
                                parseFloat(
                                    term_payment_info.avalaible_on_account
                                )
                            "
                        >
                            <h3>
                                Insufficient Funds
                                <span
                                    class="font-weight-bold"
                                    v-if="
                                        term_payment_info.avalaible_on_account >
                                            0 &&
                                        grand_total_price <=
                                            term_payment_info.avalaible_on_account
                                    "
                                >
                                    {{
                                        icPriceFormat(
                                            term_payment_info.avalaible_on_account -
                                                grand_total_price
                                        )
                                    }}
                                </span>
                                <span
                                    class="font-weight-bold"
                                    v-else-if="
                                        term_payment_info.avalaible_on_account >
                                            0 &&
                                        grand_total_price >
                                            term_payment_info.avalaible_on_account
                                    "
                                >
                                    {{
                                        icPriceFormat(
                                            grand_total_price -
                                                term_payment_info.avalaible_on_account
                                        )
                                    }}
                                </span>
                                <span class="font-weight-bold" v-else>
                                    {{ icPriceFormat(grand_total_price) }}
                                </span>
                            </h3>
                            <p class="mb_20">
                                You don't have enough funds to buy this order
                                Please add a card
                            </p>
                            <div
                                class="radio_butoons_headding d-flex mt_0 mb_30 border-top-0 border-bottom"
                                v-for="(
                                    payment_methods, indx
                                ) in all_payment_methods"
                                :key="indx"
                                :style="
                                    payment_methods.expired_time < new Date()
                                        ? 'display:none !important'
                                        : ''
                                "
                            >
                                <p class="m-0">
                                    <input
                                        type="radio"
                                        :value="
                                            payment_methods.customerPaymentProfileId
                                        "
                                        :id="
                                            payment_methods.customerPaymentProfileId +
                                            'id'
                                        "
                                        name="radio-group"
                                        @change="
                                            selectRemainingPaySavedCard(
                                                payment_methods.customerPaymentProfileId,
                                                payment_methods.expired_time,
                                                $event
                                            )
                                        "
                                    />
                                    <label
                                        :for="
                                            payment_methods.customerPaymentProfileId +
                                            'id'
                                        "
                                        class="m-0"
                                    >
                                        **** **** ****
                                        <span class="cc_opa">
                                            {{
                                                payment_methods.payment
                                                    .creditCard.cardNumber
                                                    ? payment_methods.payment.creditCard.cardNumber.substr(
                                                          -4
                                                      )
                                                    : ""
                                            }}
                                        </span>
                                    </label>
                                </p>
                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'Visa'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/add_visa_logo.png'
                                        "
                                        alt=" "
                                    />
                                </div>

                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-else-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'MasterCard'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/master_card_logo.png'
                                        "
                                        alt=" "
                                    />
                                </div>

                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-else-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'JCB'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/jcb_logo.svg'
                                        "
                                        alt=" "
                                    />
                                </div>

                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-else-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'Discover'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/discover_logo.svg'
                                        "
                                        alt=" "
                                    />
                                </div>
                                <div
                                    class="ml-auto mr_6 cards_img"
                                    v-else-if="
                                        payment_methods.payment.creditCard
                                            .cardType == 'AmericanExpress'
                                    "
                                >
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/american_express_logo.svg'
                                        "
                                        alt=" "
                                    />
                                </div>

                                <div class="ml-auto mr_6 cards_img" v-else>
                                    <img
                                        :src="
                                            base_url +
                                            '/maincss/images/unknown_card_logo.svg'
                                        "
                                        alt=" "
                                    />
                                </div>
                            </div>

                            <div
                                class="radio_butoons_headding d-flex mt_0 mb_30 border-top-0 border-bottom"
                            >
                                <p class="m-0">
                                    <label for="test1" class="m-0"
                                        ><span class="cc_opa"
                                            >Credit card</span
                                        ></label
                                    >
                                </p>
                                <img
                                    src="/maincss/images/cards.png"
                                    alt=" "
                                    class="ml-auto mr_6 cards_img"
                                />
                            </div>

                            <form
                                method="POST"
                                data-vv-scope="insufficientForm"
                            >
                                <div class="two_input_one_row mt_36">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="Card Number"
                                            name="CardNumber"
                                            placeholder="Enter Card Number"
                                            :value="
                                                '#### #### #### ' +
                                                card_info2.cardnumber
                                            "
                                            v-validate="'required|length:19'"
                                            data-vv-as="Card Number"
                                            disabled
                                        />
                                        <label class="select_option_label"
                                            >Card number</label
                                        >
                                        <span class="highlight"></span>
                                        <small
                                            class="form-text text-error text-left"
                                            v-show="
                                                errors.has(
                                                    'insufficientForm.CardNumber'
                                                )
                                            "
                                        >
                                            {{
                                                errors.first(
                                                    "insufficientForm.CardNumber"
                                                )
                                            }}
                                        </small>
                                    </div>

                                    <div
                                        class="card_detail_month_year_code d-flex align-items-baseline justify-content-between mt_18"
                                    >
                                        <div
                                            class="form-group position-relative expiration"
                                        >
                                            <label class="select_option_label"
                                                >Month</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    card_info2.cardexpiremonth
                                                "
                                                name="Expiration Month"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Month"
                                                disabled
                                            >
                                                <option
                                                    v-for="n in 12"
                                                    :value="
                                                        10 > n ? '0' + n : n
                                                    "
                                                    :key="n"
                                                    :disabled="
                                                        n <
                                                            new Date().getMonth() +
                                                                1 &&
                                                        changedYear <=
                                                            currentYear
                                                    "
                                                >
                                                    {{ 10 > n ? "0" + n : n }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'insufficientForm.Expiration Month'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "insufficientForm.Expiration Month"
                                                    )
                                                }}
                                            </small>
                                        </div>

                                        <div
                                            class="form-group position-relative expiration"
                                        >
                                            <label class="select_option_label"
                                                >Year</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    card_info2.cardexpireyear
                                                "
                                                name="Expiration Year"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Year"
                                                disabled
                                                @change="changeCardYear($event)"
                                            >
                                                <option
                                                    v-for="year in years"
                                                    :key="year"
                                                    :value="
                                                        year
                                                            ? year
                                                                  .toString()
                                                                  .substr(-2)
                                                            : ''
                                                    "
                                                >
                                                    {{ year }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'insufficientForm.Expiration Year'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "insufficientForm.Expiration Year"
                                                    )
                                                }}
                                            </small>
                                        </div>

                                        <div class="form-group securit_code">
                                            <span class="position-relative">
                                                <input
                                                    maxlength="3"
                                                    type="text"
                                                    class="form-control"
                                                    id="Security Code"
                                                    placeholder="Enter Code "
                                                    name="Security Code"
                                                    v-model="
                                                        card_info2.cardsecuritycode
                                                    "
                                                    v-validate="
                                                        'required|numeric|length:3'
                                                    "
                                                    @input="cardSecurityFormat"
                                                />

                                                <div
                                                    class="alert-icon pb-2"
                                                    data-toggle="tooltip"
                                                    data-placement="bottom"
                                                    v-tooltip="
                                                        'Credit Card Security Code'
                                                    "
                                                >
                                                    <img
                                                        src="/maincss/images/information.svg"
                                                        alt=" "
                                                    />
                                                </div>
                                            </span>
                                            <label class="select_option_label"
                                                >Security code</label
                                            >

                                            <span class="highlight"></span>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'insufficientForm.Security Code'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "insufficientForm.Security Code"
                                                    )
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="payviaterms_btn_box d-flex align-items-baseline justify-content-end mt_34 mb_0"
                                >
                                    <button
                                        data-dismiss="modal"
                                        class="btn btn_outline_primary border_primary_blue text_primary_blue design-studio-header"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        @click="payRemainingAmount"
                                        class="btn btn_orange bg_primary_orange text_white w-auto ml_20 btn_h60"
                                    >
                                        Pay
                                        <span
                                            v-if="
                                                term_payment_info.avalaible_on_account >
                                                    0 &&
                                                grand_total_price <=
                                                    term_payment_info.avalaible_on_account
                                            "
                                        >
                                            {{
                                                icPriceFormat(
                                                    term_payment_info.avalaible_on_account -
                                                        grand_total_price
                                                )
                                            }}
                                        </span>
                                        <span
                                            v-else-if="
                                                term_payment_info.avalaible_on_account >
                                                    0 &&
                                                grand_total_price >
                                                    term_payment_info.avalaible_on_account
                                            "
                                        >
                                            {{
                                                icPriceFormat(
                                                    grand_total_price -
                                                        term_payment_info.avalaible_on_account
                                                )
                                            }}
                                        </span>
                                        <span v-else>
                                            {{
                                                icPriceFormat(grand_total_price)
                                            }}
                                        </span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ADD NEW PAYMENT MODEL-->
        <div
            class="modal login-form-popup fade h-auto payment_popup"
            id="add_payment_method_model"
            tabindex="-1"
            aria-labelledby="address"
            aria-hidden="true"
            data-keyboard="false"
        >
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable payment"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">Add New Payment Method</h3>
                        <a
                            href="#"
                            @click="resetCard"
                            class="popup-close"
                            id="popup-close-paymentform"
                            data-dismiss="modal"
                        >
                            <img src="/maincss/images/cancel.svg" alt=" " />
                        </a>
                    </div>
                    <div class="modal-body">
                        <div class="address-form">
                            <form method="post" data-vv-scope="addpaymentform">
                                <div class="form-group">
                                    <div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="cardnumber"
                                            name="cardnumber"
                                            placeholder="Enter Card Number"
                                            v-model="new_card.cardnumber"
                                            v-validate="
                                                'required|min:17|max:19'
                                            "
                                            data-vv-as="Card Number"
                                            v-mask="
                                                masklength == null
                                                    ? '#### #### #### #'
                                                    : masklength == 14
                                                    ? '#### #### #### ##'
                                                    : masklength == 15
                                                    ? '#### ###### #####'
                                                    : masklength == 16
                                                    ? '#### #### #### ####'
                                                    : masklength == 17
                                                    ? '#### #### #### ####'
                                                    : '#### #### #### ####'
                                            "
                                            @input="cardNumberFormat"
                                        />
                                    </div>
                                    <label style="margin-top: -20px"
                                        >Card Number</label
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has(
                                                'addpaymentform.cardnumber'
                                            )
                                        "
                                    >
                                        {{
                                            errors.first(
                                                "addpaymentform.cardnumber"
                                            )
                                        }}
                                    </small>
                                </div>
                                <div class="form-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="cardholdername"
                                        maxlength="80"
                                        name="cardholdername"
                                        v-model="new_card.cardholdername"
                                        v-validate="'required|max:50'"
                                        data-vv-as="Card Holder"
                                        placeholder="Enter Card Holder Name"
                                    />
                                    <label class="card-holder"
                                        >Card Holder</label
                                    >
                                    <span class="highlight"></span>
                                    <span class="bar"></span>
                                    <small
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has(
                                                'addpaymentform.cardholdername'
                                            )
                                        "
                                    >
                                        {{
                                            errors.first(
                                                "addpaymentform.cardholdername"
                                            )
                                        }}
                                    </small>
                                </div>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label
                                                style="margin-top: -20px"
                                                class="select_option_label"
                                                >Month</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    new_card.cardexpiremonth
                                                "
                                                name="Expiration Month"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Month"
                                            >
                                                <option
                                                    v-for="n in 12"
                                                    :value="
                                                        10 > n ? '0' + n : n
                                                    "
                                                    :key="n"
                                                    :disabled="
                                                        (n <
                                                            (
                                                                '0' +
                                                                (new Date().getMonth() +
                                                                    1)
                                                            ).slice(-2) &&
                                                            changedYear <=
                                                                currentYear) ||
                                                        new_card.cardexpireyear <
                                                            currentYear
                                                    "
                                                >
                                                    {{ 10 > n ? "0" + n : n }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'addpaymentform.Expiration Month'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "addpaymentform.Expiration Month"
                                                    )
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label
                                                style="margin-top: -20px"
                                                class="select_option_label"
                                                >Year</label
                                            >
                                            <select
                                                class="form-control bg-transparent"
                                                v-model="
                                                    new_card.cardexpireyear
                                                "
                                                name="Expiration Year"
                                                v-validate="'required'"
                                                data-vv-as="Expiration Year"
                                                @change="
                                                    changeCardYear(
                                                        $event,
                                                        new_card
                                                    )
                                                "
                                            >
                                                <option
                                                    v-for="year in years"
                                                    :key="year"
                                                    :value="
                                                        year
                                                            .toString()
                                                            .substr(-2)
                                                    "
                                                    :disabled="
                                                        year
                                                            .toString()
                                                            .substr(-2) <
                                                        currentYear
                                                    "
                                                >
                                                    {{ year }}
                                                </option>
                                            </select>
                                            <small
                                                class="form-text text-error text-left"
                                                v-show="
                                                    errors.has(
                                                        'addpaymentform.Expiration Year'
                                                    )
                                                "
                                            >
                                                {{
                                                    errors.first(
                                                        "addpaymentform.Expiration Year"
                                                    )
                                                }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn_outline_primary border_primary_blue cancel"
                            data-dismiss="modal"
                            @click="resetCard"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            @click="addNewPaymentMethod"
                            class="btn btn_orange bg_primary_orange text_white ml_10 add"
                        >
                            Add
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon class="rect" points="0 0 0 40 40 40 40 0" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import ApiService from "@/common/api.service";

export default {
    name: "AdditionalPayment",
    directives: { mask },
    data() {
        return {
            isLoader: false,
            netsuite_customer_data: null,
            order: null,
            customer_data: {
                fullname: "",
                email: "",
                phone: ""
            },
            billing_address_data: {
                address1: "",
                address2: "",
                state: "",
                city: "",
                country: "",
                pincode: ""
            },
            shipping_address_data: {
                address1: "",
                address2: "",
                state: "",
                city: "",
                country: "",
                pincode: ""
            },
            new_card: {
                id: "",
                cardtype: "",
                cardimage: "",
                cardnumber: "",
                cardholdername: "",
                cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(-2),
                cardexpireyear: new Date().getFullYear().toString().substr(-2)
            },
            selected_card: {
                customerProfileId: "",
                customerPaymentProfileId: "",
                cardtype: "",
                cardsecuritycode: "",
                cardnumber: "",
                cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(-2),
                cardexpireyear: new Date().getFullYear().toString().substr(-2)
            },
            card_info2: {
                id: "",
                cardtype: "",
                cardimage: "",
                cardnumber: "",
                cardholdername: "",
                cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(-2), //new Date().getMonth() + 1,
                cardexpireyear: new Date().getFullYear().toString().substr(-2)
            },
            additional_fees: {
                color_fees: 0,
                item_fees: 0,
                order_fees: 0
            },
            grand_total_price: 0,
            placeorder_add_card: true,
            masklength: "",
            base_url: window.location.origin,
            currentYear: new Date().getFullYear().toString().substr(-2), //For Card Expiry Year
            changedYear: "",
            all_payment_methods: [],
            credit_limit: null,
            credit_reduce: null,
            insufficient_amount: null,
            po_number: "",
            is_saved_card: false,
            is_pay_way_terms: false,
            is_remaining_pay_card: false,
            term_payment_details: null,
            card_payment_details: null,
            unsynced_orders_amount: 0,
            total_orders: 0,
            term_payment_info: {
                creditlimit: 0,
                overdue_balance: 0,
                unbilled_orders: 0,
                unpaid_invoices: 0,
                avalaible_on_account: 0,
                unapplied_credits: 0
            }
        };
    },
    mounted() {
        if (!this.isAuthenticatedClient) {
            /* eslint-disable */
            $("#login").modal("show");
            /* eslint-enable */
            this.$router.push({ name: "/home" });
        }
        this.onLoadPage();
        this.getOrdersCount();
    },
    computed: {
        ...mapGetters(["isAuthenticatedClient", "currentUserClient"]),
        years() {
            const year = new Date().getFullYear();
            return Array.from({ length: 15 }, (value, index) => year + index);
        }
    },
    methods: {
        async onLoadPage() {
            this.isLoader = true;
            await this.getOrder();

            this.getCustomerTermDetails(this.currentUserClient.netsuite_id);

            this.prepareData();

            await this.getAllPaymentMethods();

            if (
                this.all_payment_methods &&
                this.all_payment_methods.length > 0
            ) {
                await this.selectPaymentMethod(
                    this.all_payment_methods[0].customerPaymentProfileId,
                    this.all_payment_methods[0].expired_time
                );
            }
            this.isLoader = false;
        },
        prepareData() {
            let billing_address;
            let shipping_address;

            if (this.order.NewOrderAddresses.length == 1) {
                billing_address = this.order.NewOrderAddresses[0];
                shipping_address = this.order.NewOrderAddresses[0];
            } else if (this.order.NewOrderAddresses.length > 1) {
                billing_address = this.order.NewOrderAddresses[0];
                shipping_address = this.order.NewOrderAddresses[1];
            }

            if (billing_address) {
                this.billing_address_data = {
                    address1: billing_address.address_line1,
                    address2: billing_address.address_line2,
                    state: billing_address.state,
                    city: billing_address.city,
                    country: billing_address.country,
                    pincode: billing_address.zip
                };

                this.customer_data.fullname = billing_address.fullname;
            }

            if (shipping_address) {
                this.shipping_address_data = {
                    address1: shipping_address.address_line1,
                    address2: shipping_address.address_line2,
                    state: shipping_address.state,
                    city: shipping_address.city,
                    country: shipping_address.country,
                    pincode: shipping_address.zip
                };
            }

            let modified_fees = this.order.modified_fees
                ? JSON.parse(this.order.modified_fees)
                : {};

            if (modified_fees.new_color_fee) {
                this.additional_fees.color_fees = parseFloat(
                    modified_fees.new_color_fee
                );
                this.grand_total_price += this.additional_fees.color_fees;
            }

            if (modified_fees.new_design_fee) {
                this.additional_fees.item_fees = modified_fees.new_design_fee;
                this.grand_total_price += this.additional_fees.item_fees;
            }

            if (modified_fees.order_fees) {
                this.additional_fees.order_fees = modified_fees.order_fees;
                this.grand_total_price += this.additional_fees.order_fees;
            }
        },

        getAllPaymentMethods() {
            return new Promise((resolve, reject) => {
                ApiService.get("/getAllPaymentMethods")
                    .then(({ data }) => {
                        if (!data.success) {
                            this.isLoader = false;
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.all_payment_methods = data.all_payment_methods;
                        this.all_payment_methods.forEach((method) => {
                            let expiration_date =
                                method.payment.creditCard.expirationDate;
                            method.expired_time = new Date(
                                expiration_date.split("-")[0],
                                expiration_date.split("-")[1],
                                0
                            );
                        });
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isLoader = false;
                        reject(err);
                    });
            });
        },

        getOrder() {
            return new Promise((resolve, reject) => {
                ApiService.get(`/neworderdetail/${this.$route.params.order_id}`)
                    .then(({ data }) => {
                        if (!data.success) {
                            this.isLoader = false;
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.order = data.order;

                        let term_payment_details =
                            this.order.NewOrderPayments.find(
                                (payment) =>
                                    payment.type == "termPayment" &&
                                    payment.is_additional_payment
                            );
                        if (
                            term_payment_details &&
                            term_payment_details.payment_details
                        ) {
                            term_payment_details.payment_details =
                                term_payment_details.payment_details
                                    ? JSON.parse(
                                          term_payment_details.payment_details
                                      )
                                    : null;
                        }
                        this.term_payment_details = term_payment_details;

                        let card_payment_details =
                            this.order.NewOrderPayments.find(
                                (payment) =>
                                    payment.type == "credit card" &&
                                    payment.is_additional_payment
                            );
                        if (
                            card_payment_details &&
                            card_payment_details.payment_details
                        ) {
                            card_payment_details.payment_details =
                                card_payment_details.payment_details
                                    ? JSON.parse(
                                          card_payment_details.payment_details
                                      )
                                    : null;
                        }
                        this.card_payment_details = card_payment_details;

                        resolve(data);
                    })
                    .catch((err) => {
                        this.isLoader = false;
                        console.log(err);
                        reject(err);
                    });
            });
        },

        proceedToPay() {
            return new Promise((resolve, reject) => {
                if (!this.selected_card.customerPaymentProfileId) {
                    this.$toast.error("Please select any payment method", {
                        position: "top-right",
                        queue: true
                    });
                    return;
                }

                this.$validator.validateAll("paymentform").then((isValid) => {
                    if (!isValid) {
                        return;
                    }

                    this.isLoader = true;
                    let params = {
                        order_id: this.order.id,
                        unique_order_id: this.order.unique_order_id,
                        customer_data: this.customer_data,
                        card_details: this.selected_card,
                        shipping_address: this.shipping_address_data,
                        billing_address: this.billing_address_data,
                        additional_fees: this.additional_fees,
                        grand_total_price: this.grand_total_price,
                        balance_after_order:
                            parseFloat(
                                this.term_payment_info.avalaible_on_account
                            ) - this.grand_total_price,
                        is_saved_card: this.is_saved_card
                    };
                    ApiService.post("/additional-payment", params)
                        .then(({ data }) => {
                            this.isLoader = false;
                            if (!data.success) {
                                this.$toast.error(data.error, {
                                    position: "top-right",
                                    queue: true
                                });
                                return;
                            }
                            setTimeout(() => {
                                this.$router.push({
                                    name: "thankyoupayment",
                                    params: {
                                        unique_order_id: data.unique_order_id,
                                        last_order_detail_id: null,
                                        order_id: data.order_id
                                    }
                                });
                            }, 200);
                            resolve(data);
                        })
                        .catch((err) => {
                            this.isLoader = false;
                            reject(err);
                        });
                });
            });
        },

        payViaTerms() {
            let balance_after_order =
                parseFloat(this.term_payment_info.avalaible_on_account) -
                parseFloat(this.grand_total_price);
            if (balance_after_order < 1) {
                /* eslint-disable */
                $("#insufficientFundsModal").modal("show");
                return;
                /* eslint-enable */
            }

            return new Promise((resolve, reject) => {
                this.isLoader = true;
                let params = {
                    order_id: this.order.id,
                    unique_order_id: this.order.unique_order_id,
                    customer_data: this.customer_data,
                    shipping_address: this.shipping_address_data,
                    billing_address: this.billing_address_data,
                    additional_fees: this.additional_fees,
                    grand_total_price: this.grand_total_price,
                    balance_after_order: balance_after_order,
                    term_payment_info: this.term_payment_info,
                    is_pay_way_terms: true
                };
                ApiService.post("/additional-payment", params)
                    .then(({ data }) => {
                        this.isLoader = false;
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        setTimeout(() => {
                            this.$router.push({
                                name: "thankyoupayment",
                                params: {
                                    unique_order_id: data.unique_order_id,
                                    last_order_detail_id: null,
                                    order_id: data.order_id
                                }
                            });
                        }, 200);
                        resolve(data);
                    })
                    .catch((err) => {
                        this.isLoader = false;
                        reject(err);
                    });
            });
        },

        payRemainingAmount() {
            let balance_after_order =
                parseFloat(this.term_payment_info.avalaible_on_account) -
                parseFloat(this.grand_total_price);

            return new Promise((resolve, reject) => {
                let params = {
                    order_id: this.order.id,
                    unique_order_id: this.order.unique_order_id,
                    customer_data: this.customer_data,
                    remaining_pay_card_details: this.card_info2,
                    shipping_address: this.shipping_address_data,
                    billing_address: this.billing_address_data,
                    additional_fees: this.additional_fees,
                    grand_total_price: this.grand_total_price,
                    balance_after_order: balance_after_order,
                    term_payment_info: this.term_payment_info,
                    is_pay_way_terms: true,
                    is_remaining_pay_card: true
                };

                this.$validator
                    .validateAll("insufficientForm")
                    .then((isValid) => {
                        if (!isValid) {
                            return;
                        }
                        this.isLoader = true;
                        ApiService.post("/additional-payment", params)
                            .then(({ data }) => {
                                this.isLoader = false;
                                if (!data.success) {
                                    this.$toast.error(data.error, {
                                        position: "top-right",
                                        queue: true
                                    });
                                    return;
                                }
                                /* eslint-disable */
                                $("#insufficientFundsModal").modal("hide");
                                /* eslint-enable */
                                setTimeout(() => {
                                    this.$router.push({
                                        name: "thankyoupayment",
                                        params: {
                                            unique_order_id:
                                                data.unique_order_id,
                                            last_order_detail_id: null,
                                            order_id: data.order_id
                                        }
                                    });
                                }, 200);
                                resolve(data);
                            })
                            .catch((err) => {
                                this.isLoader = false;
                                reject(err);
                            });
                    });
            });
        },

        cardNumberFormat() {
            if (this.new_card.cardnumber.replace(/\s/g, "").length < 14) {
                this.masklength = "";
            }
            if (this.new_card.cardnumber.replace(/\s/g, "").length == 14) {
                this.masklength = 14;
            }
            if (this.new_card.cardnumber.replace(/\s/g, "").length == 15) {
                this.masklength = 15;
            }
            if (this.new_card.cardnumber.replace(/\s/g, "").length == 16) {
                this.masklength = 16;
            }
            if (this.new_card.cardnumber.replace(/\s/g, "").length > 16) {
                this.masklength = 17;
            }
        },

        cardSecurityFormat() {
            var x = this.selected_card.cardsecuritycode
                .replace(/\D/g, "")
                .match(/(\d{0,3})/);
            this.selected_card.cardsecuritycode = !x[2]
                ? x[1]
                : "" + x[1] + "" + x[2] + (x[3] ? "" + x[3] : "");
        },

        changeCardYear(event, cart_data) {
            this.changedYear = event.target.value;
            if (this.changedYear == this.currentYear) {
                cart_data.cardexpiremonth = (
                    "0" +
                    (new Date().getMonth() + 1)
                ).slice(-2);
            } else {
                cart_data.cardexpiremonth = "01";
            }
        },

        selectPaymentMethod(id, expiredtime, event) {
            if (expiredtime < new Date()) {
                event.target.checked = false;
                this.is_saved_card = false;
                this.selected_card = {
                    customerProfileId: "",
                    customerPaymentProfileId: "",
                    cardtype: "",
                    cardsecuritycode: "",
                    cardnumber: "",
                    cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(
                        -2
                    ),
                    cardexpireyear: new Date()
                        .getFullYear()
                        .toString()
                        .substr(-2)
                };
                this.$toast.error("This card has expired", {
                    position: "top-right",
                    queue: true
                });
                this.$validator.reset();
                this.$forceUpdate();
                return;
            }

            this.placeorder_add_card = false;

            this.isLoader = true;
            return new Promise((resolve, reject) => {
                ApiService.get("/getSinglePaymentMethod/" + id)
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }
                        this.is_saved_card = true;
                        this.selected_card = {
                            customerProfileId:
                                data.payment_method.customerProfileId,
                            customerPaymentProfileId:
                                data.payment_method.customerPaymentProfileId,
                            cardtype:
                                data.payment_method.payment.creditCard.cardType,
                            cardsecuritycode: "",
                            cardnumber: data.payment_method.payment.creditCard
                                .cardNumber
                                ? data.payment_method.payment.creditCard.cardNumber
                                      .substr(-4)
                                      .replace(/\s/g, "")
                                : "",
                            cardexpiremonth:
                                data.payment_method.payment.creditCard.expirationDate
                                    .split("-")[1]
                                    .trim(),
                            cardexpireyear:
                                data.payment_method.payment.creditCard.expirationDate
                                    .split("-")[0]
                                    .split(/(.{2})/)
                                    .filter((x) => x.length == 2)[1]
                                    .trim()
                        };
                        this.$validator.reset();
                        this.isLoader = false;
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },

        addNewPaymentMethod() {
            this.$validator.validateAll("addpaymentform").then((isValid) => {
                if (isValid) {
                    this.isLoader = true;
                    return new Promise(() => {
                        ApiService.post("/addPaymentMethod", this.new_card)
                            .then(async ({ data }) => {
                                if (
                                    data.message ==
                                    "Payment method added successfully."
                                ) {
                                    document
                                        .getElementById(
                                            "popup-close-paymentform"
                                        )
                                        .click();
                                    this.$toast.success(data.message, {
                                        position: "top-right"
                                    });
                                    this.new_card.cardnumber = null;
                                    this.new_card.cardholdername = null;
                                    this.new_card.cardexpiremonth = (
                                        "0" +
                                        (new Date().getMonth() + 1)
                                    ).slice(-2);
                                    this.new_card.cardexpireyear =
                                        this.currentYear;

                                    this.getAllPaymentMethods().then(() => {
                                        this.selectPaymentMethod(
                                            this.all_payment_methods[0]
                                                .customerPaymentProfileId,
                                            this.all_payment_methods[0]
                                                .expired_time
                                        );
                                    });

                                    this.$validator.reset();
                                } else {
                                    this.$toast.error(data.message, {
                                        position: "top-right"
                                    });
                                }

                                if (data.error) {
                                    this.$toast.error(data.error, {
                                        position: "top-right"
                                    });
                                }
                                this.resetCard();
                                this.isLoader = false;
                            })
                            .catch((err) => {
                                console.log(err);
                                this.isLoader = false;
                            });
                    });
                }
            });
        },

        getCustomerDetailsFromNetsuite(external_id) {
            return new Promise((resolve, reject) => {
                let params = { external_id };
                ApiService.query("get-customer-from-netsuite", { params })
                    .then(async ({ data }) => {
                        this.netsuite_customer_data = data.customer;

                        let credit_limit = 0;
                        let unbilledOrders = 0;
                        if (
                            this.netsuite_customer_data &&
                            this.netsuite_customer_data.creditLimit
                        ) {
                            credit_limit =
                                this.netsuite_customer_data.creditLimit;
                        }

                        await this.getUnsyncedOrdersAmount();

                        if (
                            this.netsuite_customer_data &&
                            this.netsuite_customer_data.unbilledOrders
                        ) {
                            this.netsuite_customer_data.unbilledOrders +=
                                parseFloat(this.unsynced_orders_amount);
                            unbilledOrders =
                                this.netsuite_customer_data.unbilledOrders;
                        } else {
                            this.netsuite_customer_data.unbilledOrders =
                                parseFloat(this.unsynced_orders_amount);
                            unbilledOrders = parseFloat(
                                this.unsynced_orders_amount
                            );
                        }

                        let unpaidInvoices = 0;
                        if (
                            this.netsuite_customer_data &&
                            this.netsuite_customer_data.balance
                        ) {
                            unpaidInvoices = parseFloat(
                                this.netsuite_customer_data.balance
                            );
                        }

                        this.netsuite_customer_data.availbal =
                            parseFloat(credit_limit) -
                            parseFloat(unpaidInvoices) -
                            parseFloat(unbilledOrders);

                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },

        getCustomerTermDetails(external_id) {
            return new Promise((resolve, reject) => {
                ApiService.query("/get-customer-term-details", {
                    params: { external_id }
                })
                    .then(async ({ data }) => {
                        if (!data.success) {
                            reject(data);
                        }

                        let termDetails = data.termDetails;
                        if (termDetails.length > 0) {
                            await this.getUnsyncedOrdersAmount();

                            let term_payment_details = termDetails[0];

                            this.term_payment_info.creditlimit = parseFloat(
                                term_payment_details.creditlimit || 0
                            );
                            this.term_payment_info.overdue_balance = parseFloat(
                                term_payment_details.overdue_balance || 0
                            );
                            this.term_payment_info.unbilled_orders =
                                parseFloat(
                                    term_payment_details.unbilled_orders || 0
                                ) + parseFloat(this.unsynced_orders_amount);
                            this.term_payment_info.unpaid_invoices = parseFloat(
                                term_payment_details.unpaid_invoices || 0
                            );
                            this.term_payment_info.avalaible_on_account =
                                parseFloat(
                                    term_payment_details.avalaible_on_account ||
                                        0
                                ) - parseFloat(this.unsynced_orders_amount);
                            this.term_payment_info.unapplied_credits =
                                parseFloat(
                                    term_payment_details.unapplied_credits || 0
                                );
                        }

                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        reject(err);
                    });
            });
        },

        selectPaymentOption(option) {
            if (option == "pay_way_terms") {
                this.is_pay_way_terms = true;
                this.selected_card = {
                    customerProfileId: "",
                    customerPaymentProfileId: "",
                    cardtype: "",
                    cardsecuritycode: "",
                    cardnumber: "",
                    cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(
                        -2
                    ),
                    cardexpireyear: new Date()
                        .getFullYear()
                        .toString()
                        .substr(-2)
                };
                this.$validator.reset();
                this.$forceUpdate();
            }
        },

        selectRemainingPaySavedCard(id, expiredtime, event) {
            var _this = this;
            if (expiredtime < new Date()) {
                event.target.checked = false;
                _this.card_info2 = {
                    id: "",
                    cardtype: "",
                    cardimage: "",
                    cardnumber: "",
                    cardholdername: "",
                    cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(
                        -2
                    ),
                    cardexpireyear: new Date()
                        .getFullYear()
                        .toString()
                        .substr(-2),
                    customerPaymentProfileId: "",
                    customerProfileId: "",
                    cardsecuritycode: ""
                };
                _this.$toast.error("This card has expired", {
                    position: "top-right",
                    queue: true
                });
                _this.$validator.reset();
                _this.$forceUpdate();
                return;
            }

            _this.isLoader = true;
            new Promise(() => {
                ApiService.get("/getSinglePaymentMethod/" + id)
                    .then(({ data }) => {
                        _this.is_remaining_pay_card = false;
                        _this.card_info2.customerProfileId =
                            data.payment_method.customerProfileId;
                        _this.card_info2.customerPaymentProfileId =
                            data.payment_method.customerPaymentProfileId;
                        _this.card_info2.cardtype =
                            data.payment_method.payment.creditCard.cardType;
                        _this.card_info2.cardsecuritycode = "";
                        _this.$validator.reset();
                        _this.card_info2.cardnumber = data.payment_method
                            .payment.creditCard.cardNumber
                            ? data.payment_method.payment.creditCard.cardNumber
                                  .substr(-4)
                                  .replace(/\s/g, "")
                            : "";
                        _this.card_info2.cardexpiremonth =
                            data.payment_method.payment.creditCard.expirationDate
                                .split("-")[1]
                                .trim();
                        _this.card_info2.cardexpireyear =
                            data.payment_method.payment.creditCard.expirationDate
                                .split("-")[0]
                                .split(/(.{2})/)
                                .filter((x) => x.length == 2)[1]
                                .trim();
                        _this.card_info2.cardexpiredate =
                            _this.card_info2.cardexpiremonth +
                            "/" +
                            _this.card_info2.cardexpireyear;
                        _this.isLoader = false;
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            });
        },

        resetCard() {
            this.new_card = {
                id: "",
                cardtype: "",
                cardimage: "",
                cardnumber: "",
                cardholdername: "",
                cardexpiremonth: ("0" + (new Date().getMonth() + 1)).slice(-2),
                cardexpireyear: new Date().getFullYear().toString().substr(-2)
            };
        },

        getOrdersCount() {
            return new Promise((resolve, reject) => {
                ApiService.get("/orders-count")
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }

                        this.total_orders = data.total_orders;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        getUnsyncedOrdersAmount() {
            return new Promise((resolve, reject) => {
                ApiService.get("/unsynced-orders-amount")
                    .then(({ data }) => {
                        if (!data.success) {
                            this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            return;
                        }

                        this.unsynced_orders_amount = data.total_amount;
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        setGiftCardNumber() {
            //
        },

        setGiftCardPin() {
            //
        },

        setSpecialComment() {
            //
        },

        setCouponCode() {
            //
        }
    }
};
</script>
